/* eslint-disable no-unused-vars */
import React, { useState, useContext } from "react";

import { AppContext } from "../../../scripts/context";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";

import config from "../../../configs";
import { routes } from "../../../configs/configNavLink";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
const chainCurrencySymbol = config.get("smartContract.CHAIN_CURRENCY_SYMBOL");

/*  This Component for Connect Wallet button | khaled Mofeed | 5/12/2022 */
export default function NavbarConnect() {
  /*  imported from context AppContext | khaled Mofeed | 5/12/2022 */
  const {
    userData,
    state: { user = {}, getShortenAddress, connectWallet } = {},
    disconnect,
  } = useContext(AppContext) || {};
  const [newBalance, setNewBalance] = useState(false);
  /* This function for Connect Wallet | khaled Mofeed | 5/12/2022 */
  const handleConnectWallet = () => {
    connectWallet();
  };
  return (
    <>
      {user.address ? (
        <div className="addres-info ">
          <span className="addres-info__balance d-none">
            {newBalance || user.balance} {chainCurrencySymbol}
          </span>

          <div className="wallet-address-button-container">
            <Dropdown>
              <Dropdown.Toggle
                variant="outline-secondary"
                className="custom-secondary nav-btn"
              >
                {/* <img src={userData?.avatar} className="avatar" alt="avatar" /> */}
                <span className=" d-lg-block">
                  {getShortenAddress(user.address)}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Nav key="getShortenAddress">
                  <NavLink className="d-block d-lg-none">
                    <span className="addressUser">
                      {getShortenAddress(user.address)}{" "}
                      <i className="fas fa-location-arrow float-right"></i>
                    </span>
                  </NavLink>
                </Nav>
                {/* <Nav key="Profile">
                  <NavLink to="/profile" className="nav-link">
                    Profile
                  </NavLink>
                </Nav>
                <Nav key="Transactions">
                  <NavLink to="/transactions" className="nav-link">
                    Transactions
                  </NavLink>
                </Nav> */}

                <Dropdown.Item onClick={disconnect} key="Disconnect">
                  <img src="/img/disconnect.svg" alt="disconnect" />
                  Disconnect
                  <i className="fas fa-circle d-none d-md-none"></i>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      ) : (
        <Button
          onClick={handleConnectWallet}
          id="connect-wallet"
          variant="outline-secondary"
          type="button"
          className="custom-secondary ms-3 btn px-5"
        >
          Connect Wallet
        </Button>
      )}
    </>
  );
}
